import { render } from "./StatisticItem.vue?vue&type=template&id=16a75c5c&scoped=true"
import script from "./StatisticItem.vue?vue&type=script&lang=js"
export * from "./StatisticItem.vue?vue&type=script&lang=js"

import "./StatisticItem.vue?vue&type=style&index=0&id=16a75c5c&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a75c5c"]])

export default __exports__